import { useQuery } from 'react-query';
import { client } from 'utils/api-client';
import { useNotification } from 'components/NotificationBanner';

export default function useFetchDashboardDepartmentAvgTimeSpent(params: any) {
  const notification = useNotification();

  return useQuery(
    ['dashboard-department-avg-time', params],
    () =>
      client(`dashboard/department/average-time-spent/`, { params }).then(
        (res) => res.data
      ),
    {
      onError: (error) => {
        notification.error({
          message: 'Error occurred',
          description: error.errors,
        });
      },
    }
  );
}
